import React, { useContext, useEffect, useState } from 'react'
import { firestore } from '../../../firebase';

import SingleDetailEdit from './Templates/SingleDetailEdit';

function EditHomeDetails() {


    const [details, setDetails] = useState([]);

    useEffect(() => {

        const detailsRef = firestore.collection("site_details").doc("X0LJ5z6LWL0qF8AluQLA").collection("home_cards");
        detailsRef.onSnapshot(({docs}) => {
            const details = docs.map(doc => {
                return {id: doc.id, ...doc.data()}
            });
            setDetails(details);
        })

    }, [])


    return (
        <div className="container my-5">
            {details?.map((card, index) => {
                return (
                    <SingleDetailEdit detail={card} key={index} />
                )
            })}


        </div>
    )

}
export default EditHomeDetails